import { FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CertificateType } from "app/api/models";
import { EmailService } from "app/api/services";
import { AppLoaderService } from "app/core/services/app-loader/app-loader.service";

export function genericSendEmailError(snack: MatSnackBar) {
  snack.open(`An error has occurred when trying to send an email!`, "OK", {
    duration: 4000,
  });
}

export function sendEmailPDF(
  emailService: EmailService,
  formGroup: FormGroup,
  loader: AppLoaderService,
  snack: MatSnackBar,
  blob: Blob,
  certificateType: CertificateType,
  loadcellId: number,
) {
  emailService
    .apiEmailSendPdfCertificateEmailPost$Json({
      emailTo: formGroup.get("emailToAddress").value,
      emailSubject: formGroup.get("subjectOfEmail").value,
      emailBody: formGroup.get("emailBody").value,
      body: { formFile: blob },
      certificateType: certificateType,
      loadcellId: loadcellId,
    })
    .subscribe(
      (data) => {
        loader.close();

        if (data.data) {
          snack.open("Email sent to the customer!", "OK", {
            duration: 4000,
          });

          return true;
        } else {
          snack.open("Failed to sent!", "OK", {
            duration: 4000,
          });

          return false;
        }
      },
      (err) => {
        genericSendEmailError(snack);
        loader.close();
      }
    );
}
